import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_MONTHLY_VOLUME_ACTION_TYPE } from '../actions/commandCenterMonthlyVolume.actions';

const initialState = null;

const commandCenterMonthlyVolumeReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_MONTHLY_VOLUME_ACTION_TYPE.SET_MONTHLY_VOLUME:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default commandCenterMonthlyVolumeReducer;
